<script setup lang="ts">
import { Carousels, Property, Recommend, Toolbar, Yarn } from './components';
import { Divider, Tab, Tabs } from 'vant';
import { ToolbarContainer } from '@/components';
import { useRoute } from 'vue-router';
import { ref, watch } from 'vue';
import { type DataItem, getDataIdFromCode } from '@/api/exhibition';
import { $t } from "../../locales";

const route = useRoute();
const dataItem = ref<DataItem>();

watch(() => route.query, async () => {
  const url = route.query?.originUrl as string;
  if (url) {
    try {
      dataItem.value = await getDataIdFromCode(atob(url));
    } catch (e) {
      console.error(e);
    }
  }
}, {
  immediate: true
});
</script>

<template>
  <div :class="$style.detailPage">
    <div :class="$style.container">
      <Carousels />
      <Tabs scrollspy sticky>
        <Tab :title="$t('detail.detail')">
          <Property :data="dataItem" />
        </Tab>
        <Tab :title="$t('detail.yarn')" v-if="dataItem">
          <Divider>{{ $t('detail.yarn') }}</Divider>
          <Yarn :enterprise-id="dataItem.enterpriseId" :data-id="dataItem.id" />
        </Tab>
        <Tab :title="$t('detail.recommend')" v-if="dataItem">
          <Divider>{{ $t('detail.recommend') }}</Divider>
          <Recommend :enterprise-id="dataItem.enterpriseId" :data-id="dataItem.id" />
        </Tab>
      </Tabs>
    </div>
    <ToolbarContainer :dark="false">
      <Toolbar />
    </ToolbarContainer>
  </div>
</template>

<style module>
.detailPage {
  position: relative;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
}

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}
</style>
